// Modern Currency Switcher with Geolocation
// File: assets/currency-switcher.js

(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCurrencySwitcher);
  } else {
    initCurrencySwitcher();
  }
  
  async function initCurrencySwitcher() {

        // Skip automatic currency detection in Theme Editor to prevent refresh loop
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[Currency Switcher] Design mode detected, skipping initialization');
      return;
    }
    
    const currencySwitcher = document.getElementById('currency-switcher');
    const currentFlag = document.getElementById('current-flag');
    
    if (!currencySwitcher || !currentFlag) return;
    
    // Check if user has already selected a currency
    const hasUserPreference = getShopifyCookie('localization');
    
    if (!hasUserPreference) {
      // First-time visitor: detect location and set currency
      await detectAndSetCurrency();
    }
    
    // Get current currency from Shopify
    const currentCurrency = getCurrentCurrency();
    
    if (currentCurrency && currencySwitcher.querySelector(`option[value="${currentCurrency}"]`)) {
      currencySwitcher.value = currentCurrency;
      updateFlag(currentCurrency);
    }
    
    // Handle currency switching
    currencySwitcher.addEventListener('change', async function(e) {
      const selectedCurrency = e.target.value;
      
      // Optimistic UI update (instant feedback)
      updateFlag(selectedCurrency);
      currencySwitcher.disabled = true;
      
      // Submit to Shopify's localization endpoint
      await changeCurrency(selectedCurrency);
      
      currencySwitcher.disabled = false;
    });
  }
  
  async function detectAndSetCurrency() {
    try {
      // Use Shopify's built-in country detection if available
      if (window.Shopify && window.Shopify.country) {
        const country = window.Shopify.country;
        const currency = getDefaultCurrencyForCountry(country);
        if (currency) {
          await changeCurrency(currency, true);
          return;
        }
      }
      
      // Fallback: Use Cloudflare's geolocation (free, fast, no API key needed)
      const response = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
      const data = await response.text();
      const countryMatch = data.match(/loc=([A-Z]{2})/);
      
      if (countryMatch) {
        const country = countryMatch[1];
        const currency = getDefaultCurrencyForCountry(country);
        if (currency) {
          await changeCurrency(currency, true);
        }
      }
    } catch (error) {
      console.log('Geolocation detection skipped:', error);
      // Fallback to GBP if geolocation fails
      await changeCurrency('GBP', true);
    }
  }
  
  function getDefaultCurrencyForCountry(countryCode) {
    // GBP only for UK, EUR for all other countries
    if (countryCode === 'GB') {
      return 'GBP';
    }
    
    // All other countries get EUR
    return 'EUR';
  }
  
  async function changeCurrency(currency, isAutoDetection = false) {
    try {
      // Update Shopify's localization via official endpoint
      const formData = new FormData();
      formData.append('currency_code', currency);
      formData.append('return_to', window.location.pathname + window.location.search);
      
      await fetch('/localization', {
        method: 'POST',
        body: formData
      });
      
      // Reload with currency parameter for immediate visual update
      const url = new URL(window.location.href);
      url.searchParams.set('currency', currency);
      
      // For auto-detection on first load, use replace to avoid back button issues
      if (isAutoDetection) {
        window.location.replace(url.toString());
      } else {
        window.location.href = url.toString();
      }
      
    } catch (error) {
      console.error('Currency switch failed:', error);
      // Fallback: direct URL change
      const url = new URL(window.location.href);
      url.searchParams.set('currency', currency);
      window.location.href = url.toString();
    }
  }
  
  async function updatePricesOnPage(currency) {
    // For instant visual feedback, update the money elements
    // This works with Shopify's standard money format elements
    const moneyElements = document.querySelectorAll('[data-currency-' + currency.toLowerCase() + ']');
    
    moneyElements.forEach(el => {
      const newPrice = el.dataset['currency' + currency.toLowerCase()];
      if (newPrice) {
        el.textContent = newPrice;
      }
    });
  }
  
  function getCurrentCurrency() {
    // Try Shopify's active currency first
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active.toUpperCase();
    }
    
    // Check Shopify's localization cookie
    const localizationCookie = getShopifyCookie('localization');
    if (localizationCookie) {
      try {
        const parsed = JSON.parse(decodeURIComponent(localizationCookie));
        if (parsed.currency) {
          return parsed.currency.toUpperCase();
        }
      } catch (e) {
        // Invalid JSON, continue to fallback
      }
    }
    
    // Check URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const urlCurrency = urlParams.get('currency');
    if (urlCurrency) return urlCurrency.toUpperCase();
    
    // Default to GBP
    return 'GBP';
  }
  
  function updateFlag(currency) {
    const currencySwitcher = document.getElementById('currency-switcher');
    const currentFlag = document.getElementById('current-flag');
    
    if (!currencySwitcher || !currentFlag) return;
    
    const option = currencySwitcher.querySelector(`option[value="${currency}"]`);
    if (option && option.dataset.imgUrl) {
      currentFlag.src = option.dataset.imgUrl;
      currentFlag.alt = `${currency} flag`;
    }
  }
  
  function getShopifyCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
})();